export default "__VITE_PUBLIC_ASSET__95c5e0be__"